<template>
  <div>
    <!--Breadcrumb button-->
    <breadcrumb-button>
      <template #beforeDropdown>
        <b-button variant="success" class="btn-icon" @click="onNewTicket"
                  v-if="hasPermission(permissions.TICKET_CREATE)"
        >
          <feather-icon icon="PlusIcon" size="16"/>
        </b-button>
      </template>
    </breadcrumb-button>

    <!--Filters-->
    <filter-card v-model="filter" v-bind:fields="filterFields" search/>

    <!-- Table -->
    <b-card no-body>
      <b-card-header class="pb-50">
        <h5>{{ $t('menu.tickets') }}</h5>
      </b-card-header>
      <b-card-body>
        <tickets-table
            ref="ticketsTable"
            v-bind:filters="filter"
            :lazy="true"
            @selected="onTicketSelected"
        />
      </b-card-body>
    </b-card>

    <!--Modal-->
    <ticket-modal ref="ticket-modal" @submitted="onTicketSubmitted"/>
  </div>
</template>

<script>
import BreadcrumbButton from '@/components/widget/breadcrumbButton'
import FilterCard from '@/components/widget/FilterCard'
import TicketsTable from '@/components/tables/TicketsTable'
import TicketModal from '@/components/modal/TicketModal'
import TicketSearchRequest from '@/model/ticket/TicketSearchRequest'
import TicketFilterFields from '@/model/filter/TicketFilterFields'
import mixinPermissions from '@/components/mixin/mixinPermissions'
import mixinBase from '@/components/mixin/mixinBase'
import Permissions from '@/model/Permissions'

export default {
  name: 'TicketsView',
  components: {
    TicketsTable,
    TicketModal,
    FilterCard,
    BreadcrumbButton,
  },
  mixins: [mixinBase, mixinPermissions],
  data() {
    return {
      filter: TicketSearchRequest({ statuses: ['REQUEST', 'IN_PROGRESS', 'WAITING_FOR_USER_RESPONSE'] }),
      filterFields: null,
      permissions: Permissions,
    }
  },
  created() {
    this.filterFields = TicketFilterFields(this)
  },
  methods: {
    onNewTicket() {
      this.$refs['ticket-modal'].showModal(null)
    },
    onTicketSelected(id) {
      this.$refs['ticket-modal'].showModal(id)
    },
    onTicketSubmitted() {
      this.$refs['ticketsTable'].refresh()
    },
  }
}
</script>
